// eslint-disable-next-line no-restricted-imports
import { Skeleton } from '@workday/canvas-kit-react/skeleton';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';

const ThemedSkeletonShape = (props: React.ComponentProps<typeof Skeleton.Shape>) => (
  <Skeleton.Shape backgroundColor={WcpStyles.color.bg.alt.soft} {...props} />
);

const ThemedSkeletonText = (props: React.ComponentProps<typeof Skeleton.Text>) => (
  <Skeleton.Text backgroundColor={WcpStyles.color.bg.alt.soft} {...props} />
);

const ThemedSkeletonHeader = (props: React.ComponentProps<typeof Skeleton.Header>) => (
  <Skeleton.Header backgroundColor={WcpStyles.color.bg.alt.soft} {...props} />
);

export const ThemedSkeleton = (props: React.ComponentProps<typeof Skeleton>) => <Skeleton {...props} />;
ThemedSkeleton.Shape = ThemedSkeletonShape;
ThemedSkeleton.Text = ThemedSkeletonText;
ThemedSkeleton.Header = ThemedSkeletonHeader;
